module.exports = __webpack_public_path__ + "img/music-work-icon8.246bcff4.png";